// report.component.ts
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AppConstants } from '../AppConstants';
import { AuthService } from '../service/auth.service';
import * as moment from 'moment';
import { ColDef, ValueFormatterParams } from 'ag-grid-community';
import { APIRoutes } from '../APIRoutes';
import { ReportDownloadService } from '../service/report-download.service';


@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {
  reportForm: FormGroup;
  products: any[] = [];
  venues: any[] = [];
  reportData: any[] = [];
  maxDateRange = 90; // in days
  tenantId;
  periods: string[] = ['Today', 'Yesterday', 'Last 7 Days', 'Last 30 Days', 'Last Month',  'Custom']; //'Last 3 Months',
  dropdownProductSettings = {};
  dropdownVenueSettings = {};
  roleId;
  externalUserContext;
  currentUserContext;
  downloading = false;


  columnDefs: ColDef[] = [
    { field: 'productName', headerName: 'PRODUCT', width: 160 },
    { field: 'venueName', headerName: 'VENUE', width: 160 },
     { field: 'userName', headerName: 'USER' },
    { field: 'bookingId', headerName: 'BOOKING ID', width: 130 },
/*     { field: 'userEmail', headerName: 'Email' },
    { field: 'userPhone', headerName: 'Phone' }, */
    { field: 'bookingDateTime', headerName: 'BOOKED ON', valueFormatter: (params: ValueFormatterParams) => this.formatDateTime(params.value) , width: 150},
    { field: 'bookingDate', headerName: 'SLOT DATE', valueFormatter: (params: ValueFormatterParams) => this.formatDate(params.value), width: 130 },
    {
      field: 'endDate',
      headerName: 'END DATE',
      width: 130,
      valueFormatter: (params: ValueFormatterParams) => this.formatDate(params.value)
    },
    { field: 'bookingStatus', headerName: 'STATUS', width: 100 },
    { field: 'amount', headerName: 'AMOUNT', width: 120 },
    { field: 'paymentType', headerName: 'PAYMENT', width: 130 },
    { field: 'transactionId', headerName: 'TXN ID' , width: 150 },
    { field: 'transactionStatus', headerName: 'TXN STATUS' },
    { field: 'startTime', headerName: 'START TIME', width: 100 },
    { field: 'endTime', headerName: 'END TIME', width: 100 }
  ];

  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
  };

  constructor(private fb: FormBuilder, private http: HttpClient, private authService: AuthService,
              private reportDownload: ReportDownloadService) {

/*   */

    this.reportForm = this.fb.group({
      period: ['Today'],
      startDate: [null],
      endDate: [null],
      productIds: [[]],
      venueIds: [[]]
    });
  }

  ngOnInit(): void {

    this.externalUserContext = sessionStorage.getItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT);
    this.currentUserContext = sessionStorage.getItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT);
    //console.log('Reports Page Current User', this.currentUserContext);
    //console.log('Reports Page Ext User', this.externalUserContext);


    this.tenantId = JSON.parse(sessionStorage.getItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT)).tenantId;
    //console.log("Transactions Tenant Id 2", AppConstants.SESSION_STORAGE_TENANTID);



    if (this.externalUserContext) {
      this.roleId = JSON.parse(this.externalUserContext).roleId;
    } else if (this.currentUserContext) {
      this.roleId = JSON.parse(this.currentUserContext).roleId;
    } else {
      this.roleId = 0; // user not logged in
    }
    const feeColumns: ColDef[] = [
      { field: 'platformFeeBusiness', headerName: 'Charges', width: 150 }
    ];
    if (Number(this.roleId) === 1) {
      feeColumns.push({ field: 'platformFeeEndUser', headerName: 'End user fee', width: 150 });
    }
    const amountColumnIndex = this.columnDefs.findIndex(col => col.field === 'amount');
    this.columnDefs = [
      ...this.columnDefs.slice(0, amountColumnIndex + 1),
      ...feeColumns,
      ...this.columnDefs.slice(amountColumnIndex + 1)
    ];
    if (this.roleId == 1) {
        this.tenantId = AppConstants.SESSION_STORAGE_TENANTID;
        console.log("Super Admin tenant Id", AppConstants.SESSION_STORAGE_TENANTID);
      }
      else
      {
        this.tenantId = JSON.parse(sessionStorage.getItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT)).tenantId;
      }

      //console.log("Report Constructor tenant Id", this.tenantId);

    this.dropdownProductSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'productName',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.dropdownVenueSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'venueName',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.getAllProductsByTenantId();
    this.getAllVenuesByTenantId(this.tenantId);
    //this.fetchVenues();
    this.setPeriod('Today');
  }

  fetchProducts() {
    this.http.get(APIRoutes.GET_ALL_PRODUCTS_BY_TENANTID + this.tenantId)
      .subscribe((res: any) => this.products = res);
  }

  getAllProductsByTenantId() {
    console.log("Function: getAllProductsByTenantId ");
    console.log("Tenant Id",  AppConstants.SESSION_STORAGE_TENANTID);
   /*  if(AppConstants.SESSION_STORAGE_ROLEID == 1)
    {
      this.tenantId = AppConstants.SESSION_STORAGE_TENANTID;
    } */

    //console.log("product tenant id",  this.tenantId);
    this.authService.getAllProductsByTenantId(this.tenantId).subscribe(
      (response: any[]) => {
        this.products = response;
      },
      (error) => {

      }
    );
    console.log("product tenant id",  this.products);

  }
  getAllVenuesByTenantId(tenantId) {
    this.authService.getAllVenuesByTenantId(tenantId).subscribe(
      (response: any) => {
        this.venues =response ;
      },
      (error) => {
        console.log('getAllVenuesByTenantId - ' + JSON.stringify(error));
      }
    );

    console.log("venues",  this.venues);
  }
  fetchVenues() {
    this.http.get(APIRoutes.GET_ALL_VENUES_BY_TENANTID + this.tenantId)
      .subscribe((res: any) => this.venues = res);
  }

  setPeriod(period: string): void {
    const today = new Date();
    let startDate: Date;
    let endDate: Date;

    switch (period) {
      case 'Today':
        startDate = endDate = today;
        break;

      case 'Yesterday':
        startDate = endDate = new Date(today);
        startDate.setDate(startDate.getDate() - 1);
        break;

      case 'Last 7 Days':
        endDate = today;
        startDate = new Date(today);
        startDate.setDate(startDate.getDate() - 6);
        break;

      case 'Last 30 Days':
        endDate = today;
        startDate = new Date(today);
        startDate.setDate(startDate.getDate() - 29);
        break;

      case 'Last Month':
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;

     /*  case 'Last 3 Months':
        startDate = new Date(today.getFullYear(), today.getMonth() - 3, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break; */

      case 'Custom':
        return; // user input will decide dates

      default:
        return;
    }

    this.reportForm.patchValue({
      startDate: this.formatDate2(startDate),
      endDate: this.formatDate2(endDate),
    });
  }

  formatDate2(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }


  isCustomPeriod(): boolean {
    return this.reportForm.get('period')?.value === 'Custom';
  }

  validateDateRange(): boolean {
    const { startDate, endDate } = this.reportForm.value;
    if (startDate && endDate) {
      const diff = moment(endDate).diff(moment(startDate), 'days');
      return diff <= this.maxDateRange;
    }
    return true;
  }

  fetchReport() {
    if (!this.validateDateRange()) {
      alert('Date range cannot exceed 3 months');
      return;
    }
    const productIdsArray = this.reportForm.value.productIds.map((p: any) => p.id || p).join(',');
    const venueIdsArray = this.reportForm.value.venueIds.map((v: any) => v.id || v).join(',');

    console.log("productIdsArray", productIdsArray);
    console.log("venueIdsArray", venueIdsArray);

    const body = {
      startDate: moment(this.reportForm.value.startDate).format('YYYY-MM-DD'),
      endDate: moment(this.reportForm.value.endDate).format('YYYY-MM-DD'),
      productIds: this.reportForm.value.productIds.map((p: any) => p.id.toString() || p),
      venueIds: this.reportForm.value.venueIds.map((v: any) => v.id.toString() || v)
    };
    console.log("body", body);

   /*  this.http.post<any[]>(`/book-now/v1/report/${this.tenantId}`, body)
      .subscribe(res => this.reportData = res); */

    this.authService.fetchReport(this.tenantId, body).subscribe(
          (response: any[]) => {
            this.reportData = response;
	    this.updateSummaryMetrics();
          },
          (error) => {

          }
    );

    console.log("Report Data", this.reportData);
  }

  formatDateTime(dateStr: string): string {
    return moment(dateStr).utcOffset('+0530').format('YYYY-MM-DD HH:mm');
  }

  formatDate(millis: number): string {
    if (!millis) return ''; // ✅ handle missing endDate
    return moment(millis).utcOffset('+0530').format('YYYY-MM-DD');
  }

  async downloadCSV(): Promise<void> {
    if (this.downloading) return;
    this.downloading = true;
    try {
      const escapeCell = (value: unknown): string => `"${String(value ?? '').replace(/"/g, '""')}"`;
      const header = this.columnDefs.map(col => escapeCell(col.headerName));
      const csvRows = this.reportData.map(row => {
        return this.columnDefs.map(col => {
          const val = row[col.field as keyof typeof row];
          const formatter = col.valueFormatter as ((params: ValueFormatterParams) => string) | undefined;
          return escapeCell(formatter ? formatter({ value: val } as ValueFormatterParams) : val);
        }).join(',');
      });

      await this.reportDownload.save([header.join(','), ...csvRows].join('\r\n'));
    } catch (error) {
      alert('Unable to download the report. Please try again.');
    } finally {
      this.downloading = false;
    }
  }

  summary = {
    total: 0,
    totalAmount: 0,
    booked: 0,
    bookedAmount: 0,
    cancelled: 0,
    cancelledAmount: 0,
    failed: 0,
    failedAmount: 0
  };

  updateSummaryMetrics() {
    this.summary = {
      total: this.reportData.length,
      totalAmount: this.getAmountSum(),
      booked: this.countByStatus('Booked'),
      bookedAmount: this.sumByStatus('Booked'),
      cancelled: this.countByStatus('Cancelled'),
      cancelledAmount: this.sumByStatus('Cancelled'),
      failed: this.countByStatus('Failed'),
      failedAmount: this.sumByStatus('Failed'),
    };
  }

  getAmountSum(): number {
    return this.reportData.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);
  }

  countByStatus(status: string): number {
    return this.reportData.filter(r => r.bookingStatus === status).length;
  }

  sumByStatus(status: string): number {
    return this.reportData
      .filter(r => r.bookingStatus === status)
      .reduce((sum, r) => sum + (Number(r.amount) || 0), 0);
  }
}
